import React, { useEffect, useState } from "react";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import { useData } from "../../../components/firebase/DataProvider";
import Header from "../../../components/molecules/Header";
import useStyles from "./style";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Skeleton from "@material-ui/lab/Skeleton";
import Grid from "@material-ui/core/Grid";
import Gap from "../../../components/Gap";
import MatahariUang1 from "../../../assets/icon/matahariuang1";
import MatahariUang2 from "../../../assets/icon/matahariuang2";
import Detail from "./detail";
import Button from "@material-ui/core/Button";

const SkeletonLoader = () => {
  const classes = useStyles();

  const data = [1, 2, 3, 4, 5, 6];
  return (
    <>
      {data.map((item) => (
        <Grid className={classes.wrapVoucher}>
          <Card className={classes.cardVoucher}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="rect" width={50} height={50} />
            </div>
            <Gap width={15} />
            <div style={{ width: "100%" }}>
              <Skeleton width="50%" />
              <Skeleton width="40%" />
              <Skeleton width="10%" />
            </div>
          </Card>
        </Grid>
      ))}
    </>
  );
};

function TokoramePoint() {
  const history = useHistory();
  const classes = useStyles();
  const { level, profil } = useData();
  const [data, setData] = useState([]);
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialogDetail, setDialogDetail] = useState({ open: false, data: "" });
  const getData = async () => {
    setLoading(true);

    try {
      const funcProfile = await firefunctions.httpsCallable("inpoin-profile")();
      setProfile(funcProfile?.data?.data ?? []);
      const funcList = await firefunctions.httpsCallable(
        "inpoin-listVoucher"
      )();
      setData(funcList?.data?.data?.voucher ?? []);
      setLoading(false);
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            await firefunctions.httpsCallable("inpoin-login")();
          } catch (error) {
            console.log("-loginInpoin", error);
          }
        };
        loginInpoin();
      }
      console.log("-listVoucher", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Header
        type="with-title"
        title="Tokorame Coin"
        onClick={() => history.push("/")}
      />
      <div className={classes.wrap}>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card className={classes.wrapCard}>
                <div className={classes.wrapContentTitle}>
                  <Typography className={classes.liquidCardTitle}>
                    {profil?.nama}
                  </Typography>
                  <Typography className={classes.liquidCardPrimary}>
                    {level?.level ?? "Level"}
                  </Typography>
                </div>
                <Divider style={{ backgroundColor: "white" }} />
                <div className={classes.wrapContentCard}>
                  <div>
                    <Typography className={classes.liquidCardPrimary}>
                      Tokorame Coin
                    </Typography>
                    <Typography className={classes.liquidCardSecondary}>
                      {profile?.profiles?.coin}
                    </Typography>
                  </div>
                  <div>
                    <Typography className={classes.liquidCardPrimary}>
                      Status
                    </Typography>
                    <Typography className={classes.liquidCardSecondary}>
                      {profile?.profiles?.status ?? "status"}
                    </Typography>
                  </div>
                </div>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card>
                <CardActionArea
                  onClick={() => history.push("/tokoramecoin/riwayat")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 10,
                    }}
                  >
                    <Typography variant="body2">
                      Riwayat Tokorame <br /> Coin
                    </Typography>
                    <div>
                      <MatahariUang1 />
                    </div>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card>
                <CardActionArea
                  onClick={() => history.push("/tokoramecoin/info")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 10,
                    }}
                  >
                    <Typography variant="body2">
                      Info Tokorame <br /> Coin
                    </Typography>
                    <div>
                      <MatahariUang2 />
                    </div>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </Container>
        <Gap height={30} />
        <Container style={{ backgroundColor: "#EFF1FF", minHeight: "100vh" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid>Voucher Tokorame</Grid>
              {loading ? (
                <SkeletonLoader />
              ) : (
                data
                  ?.sort((a, b) => b.availableVoucher - a.availableVoucher)
                  .map((item) => {
                    return (
                      <Grid className={classes.wrapVoucher}>
                        <Card
                          elevation={0}
                          onClick={() =>
                            setDialogDetail({ open: true, data: item })
                          }
                        >
                          <div className={classes.cardVoucher}>
                            <div className={classes.wrapThumb}>
                              <img
                                alt={item?.name}
                                src={item?.headerImage}
                                className={classes.thumb}
                              />
                            </div>
                            <Gap width={15} />
                            <div>
                              <Typography
                                className={classes.liquidVocherPrimary}
                              >
                                {item?.name}
                              </Typography>
                              <Typography
                                className={classes.liquidVocherSecondary}
                              >
                                {item?.category}
                              </Typography>
                              <Typography
                                className={classes.liquidVocherSecondary}
                              >
                                {item?.description.slice(0, 70)}...
                              </Typography>
                            </div>
                          </div>
                        </Card>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginRight: "10px",
                            marginLeft: "10px",
                            padding: "10px",
                            backgroundColor: "#F1F1F1",
                            borderRadius: "0px 0px 10px 10px",
                            zIndex: -99,
                          }}
                        >
                          <div>
                            <Typography className={classes.liquidPont}>
                              {item.coin} tokorame coin
                            </Typography>
                          </div>
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={item.availableVoucher == 0}
                              onClick={() =>
                                setDialogDetail({ open: true, data: item })
                              }
                            >
                              <Typography className={classes.liquidBtn}>
                                {item.availableVoucher > 0
                                  ? "Tukar Coin"
                                  : "Habis"}
                              </Typography>
                            </Button>
                          </div>
                        </div>
                      </Grid>
                    );
                  })
              )}
            </Grid>
          </Grid>
        </Container>
      </div>
      <Detail
        open={dialogDetail.open}
        data={dialogDetail.data}
        handleClose={() => setDialogDetail({ open: false, data: "" })}
      />
    </>
  );
}

export default TokoramePoint;
